import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import ReactGA from 'react-ga';
import {default as Reactsel} from 'react-select';

class ActivityLeaderboard extends Component {
	constructor(props) {
		super(props)
    	this.state = {
            fetchStatus: false,
            selectedActivity: '',
    		data: {
    			boardDetails: [],
                activityDropDown: [],
                activityScore: '',
                activityRank: ''
    		}	
    	}
    }

    handleActivityChange = (option) => {
        this.setState(state => {
            return {
                selectedActivity : option
            };
        });
    }

    handleLeaderboardFetch = () => {
        let data = Object.assign({}, this.state.data)

        let fetchLeaderboard = `user/leaderboard/activity/${this.state.selectedActivity.value}`
        api.getUserResponse(this.props.user.accessToken, fetchLeaderboard)
        .then((result) => {
            if (result.status === 'success') {
                data.boardDetails = result.data.leaderboard
                data.activityScore = result.data.activity_score
                data.activityRank = result.data.activity_rank
                this.setState({data: data, fetchStatus: true})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while fetching. Please try again after sometime.'})
            }
        })
    }

    componentDidMount(){
        //ReactGA.set({ userId: this.props.user.id });
        //ReactGA.initialize('UA-139837993-1');
        //ReactGA.pageview('/acitivity_details');
        let data = Object.assign({}, this.state.data)

        let fetchDropDown = 'user/leaderboard/reward_type'

        return api.getUserResponse(this.props.user.accessToken, fetchDropDown)
        .then((result) => {
            if (result.status === 'success') {
                data.activityDropDown = result.data
                var a = {};
                a["value"] = 0;
                a["label"] = "Overall Score";
                data.activityDropDown.push(a)
                //var b = {};
                //b["value"] = -1;
                //b["label"] = "Monthly Score";
                //data.activityDropDown.push(b)
                this.setState({data: data, fetchStatus: false})
            }
        })
    }

    render() {
        let handleLeaderboardFetch = this.handleLeaderboardFetch
        let userName = this.props.user.userName
        let scoreComponent
    	let tableComponent = (
            <tbody>
                {this.state.data.boardDetails.map(function(board){
            		let uniq = Math.random() * parseInt(board.points)
	            	if (board.user_name === userName) {
                        return(
                            <tr>
                                <td><b>{board.first_name} {board.last_name}</b></td>
                                <td><b>{board.points}</b></td>
                            </tr>
                        )
                    }
                    else {
                        return(
                            <tr>
                                <td>{board.first_name} {board.last_name}</td>
                                <td>{board.points}</td>
                            </tr>
                        )
                    }
	        })}
            </tbody>
        )

        if (this.props.isAdmin === false) {
            if (this.state.fetchStatus === true){
                scoreComponent = (
                    <GridCell span="12">
                        Your total Chalk Points are <b>{this.state.data.activityScore} </b>
                         and Your Rank is <b>{this.state.data.activityRank}</b>
                    </GridCell>
                )
            }
        }

        return (
        	<div>
                <Grid>
                    <GridCell span = "6">
                        <Typography> Please select an activity from the drop down to view the leaderboard of that activity </Typography>
                    </GridCell>
                    <GridCell span = "4">
                        <Reactsel
                            name="activity-list"
                            onChange={this.handleActivityChange}
                            value={this.state.selectedActivity}
                            options={this.state.data.activityDropDown}
                            placeholder="--Select an Activity--" >
                        </Reactsel>
                    </GridCell>
                    <GridCell span = "2">
                        <Button raised style={{ width: '66%' }} onClick = {((e) => handleLeaderboardFetch(e))}>View</Button>
                    </GridCell>
                </Grid>
                <Grid>
                    {scoreComponent}
	        		<GridCell span="12">
	        			<table>
				            <th>Name</th>
				            <th>Points</th>
				            {tableComponent}
	        			</table>
	        		</GridCell>
	      		</Grid>
        	</div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLeaderboard);


// WEBPACK FOOTER //
// ./src/views/rewards_user/ActivityLeaderboard.jsx